"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardValidationConfig = exports.genderOptions = exports.voucherTableColums = exports.subscriptionTableColums = exports.productsData = exports.data = exports.employeeStatuses = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment_1 = __importDefault(require("moment"));
var formatDate_1 = require("../../../../helpers/formatDate");
var constants_1 = require("../../constants");
exports.employeeStatuses = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "BLOCKED", label: "BLOCKED" },
    { value: "DORMANT", label: "DORMANT" },
];
exports.data = [
    {
        _id: "1",
        hearder1: "Data 1",
        header2: "Data 2",
        header3: "Data 3",
        header4: "Data 4",
        header5: "Data 5",
        header6: "Data 6",
        header7: "Data 7",
    },
    {
        _id: "2",
        hearder1: "Data 1",
        header2: "Data 2",
        header3: "Data 3",
        header4: "Data 4",
        header5: "Data 5",
        header6: "Data 6",
        header7: "Data 7",
    },
    {
        _id: "3",
        hearder1: "Data 1",
        header2: "Data 2",
        header3: "Data 3",
        header4: "Data 4",
        header5: "Data 5",
        header6: "Data 6",
        header7: "Data 7",
    },
];
exports.productsData = [
    {
        _id: "1",
        title: "Biogen Milk Thistle 60's",
        sku: "6009544931331",
        qty: "2",
        price: "R 129.99",
        estTime: "3 to 5 hours",
        type: "Core",
        parcel: "P-LXQOM",
        r_status: "SUPPLIER",
        status: "Packed",
    },
    {
        _id: "2",
        title: "Aqua Base 500g",
        sku: "6931331009544",
        qty: "1",
        price: "R 66.99",
        estTime: "3 to 5 hours",
        type: "Core",
        parcel: "P-LPAJK",
        r_status: "STOCK",
        status: "Collected",
    },
    {
        _id: "3",
        title: "Mitchum Invisible Ron Lady Value Added Pack 2 x 50ml",
        sku: "6009544931331",
        qty: "2",
        price: "R 11.99",
        estTime: "3 to 5 hours",
        type: "Core",
        status: "Collected",
    },
    {
        _id: "4",
        title: "Biogen Milk Thistle 60's",
        sku: "4493160095331",
        qty: "3",
        price: "R 89.99",
        estTime: "3 to 5 hours",
        type: "Core",
        status: "Collected",
    },
    {
        _id: "5",
        title: "Biogen Milk Thistle 60's",
        sku: "6009531331449",
        qty: "1",
        price: "R 277.99",
        estTime: "3 to 5 hours",
        type: "Core",
        status: "Collected",
    },
];
exports.subscriptionTableColums = [
    {
        displayKey: "image",
        label: "Image",
        formatter: function (data) {
            if (data === null || data === void 0 ? void 0 : data.image) {
                return (0, jsx_runtime_1.jsx)("img", { className: "w-10 aspect-square rounded-lg", src: data === null || data === void 0 ? void 0 : data.image });
            }
            else {
                return "";
            }
        },
    },
    {
        displayKey: "name",
        label: "Title",
    },
    {
        displayKey: "createdAt",
        label: "Start Date",
        formatter: function (_) { return (0, formatDate_1.formatDate)(_.createdAt); },
    },
    {
        displayKey: "end_date",
        label: "End Date",
        formatter: function (data) {
            var _a, _b;
            if ((_a = data === null || data === void 0 ? void 0 : data.redemption) === null || _a === void 0 ? void 0 : _a.last_redemption_date) {
                return (0, formatDate_1.formatDate)((_b = data === null || data === void 0 ? void 0 : data.redemption) === null || _b === void 0 ? void 0 : _b.last_redemption_date);
            }
            else if (data === null || data === void 0 ? void 0 : data.redemption.createdAt) {
                return (0, moment_1.default)(data === null || data === void 0 ? void 0 : data.redemption.createdAt).add(parseInt(data === null || data === void 0 ? void 0 : data.expires_in), "days").format("DD-MM-YYYY");
            }
            else {
                return "";
            }
        },
    },
    {
        displayKey: "free_trial",
        label: "Free Trial",
        formatter: function (data) {
            if (data === null || data === void 0 ? void 0 : data.free_trial) {
                return "True";
            }
            else {
                return "False";
            }
        },
    },
    {
        displayKey: "payment_type",
        label: "Payment Type",
    },
    {
        displayKey: "last_redemption_date",
        label: "Last Redemption Date",
        formatter: function (_) { return (0, formatDate_1.formatDate)(_.last_redemption_date); },
    },
    {
        displayKey: "status",
        label: "Status",
        formatter: function (_) {
            var _a;
            if (_ === null || _ === void 0 ? void 0 : _.redemption) {
                return (0, constants_1.TABLE_STATUSES)((_a = _ === null || _ === void 0 ? void 0 : _.redemption) === null || _a === void 0 ? void 0 : _a.status);
            }
        },
    },
];
exports.voucherTableColums = [{
        displayKey: "image",
        label: "Image",
        formatter: function (data) {
            if (data === null || data === void 0 ? void 0 : data.image_url) {
                return (0, jsx_runtime_1.jsx)("img", { className: "w-10 aspect-square rounded-lg", src: data === null || data === void 0 ? void 0 : data.image_url });
            }
            else {
                return "";
            }
        },
    },
    {
        displayKey: "name",
        label: "Voucher name",
    },
    {
        displayKey: "date_range",
        label: "Start Date",
        formatter: function (_) { return (0, formatDate_1.formatDate)(_.date_range.from); },
    },
    {
        displayKey: "date_range",
        label: "End Date",
        formatter: function (_) { return (0, formatDate_1.formatDate)(_.date_range.to); },
    },
    {
        displayKey: "status",
        label: "Status",
        formatter: function (_) {
            var _a;
            if (_ === null || _ === void 0 ? void 0 : _.redemption) {
                return (0, constants_1.TABLE_STATUSES)((_a = _ === null || _ === void 0 ? void 0 : _.redemption) === null || _a === void 0 ? void 0 : _a.status);
            }
            else {
                return (0, constants_1.TABLE_STATUSES)(_ === null || _ === void 0 ? void 0 : _.status);
            }
        },
    },
    {
        displayKey: "quantity",
        label: "Quantity",
    },];
exports.genderOptions = [
    { value: "MALE", label: "MALE" },
    { value: "FEMALE", label: "FEMALE" },
    { value: "OTHER", label: "OTHER" },
    { value: "N/A", label: "N/A" },
];
exports.cardValidationConfig = {
    number: { name: "loyalty card number", charLength: 15 },
};
